import Vue from "vue";
import Vuetify from "vuetify/lib";

import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

import es from 'vuetify/src/locale/es.ts'

Vue.component('my-component', {
  methods: {
    changeLocale() {
      this.$vuetify.lang.current = 'es'
    },
  },
})

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#2751a3",
      },
      dark: {
        primary: colors.indigo,
      },
    },
  },

  icons: {
    iconfont: "md",
  },
});
